import { AdContentTimePosition } from '@quickplay/player-interface';

export function toAdContentTimePosition(timePosition: string): AdContentTimePosition {
  switch (timePosition) {
    case 'preroll':
      return AdContentTimePosition.PREROLL;
    case 'midroll':
      return AdContentTimePosition.MIDROLL;
    case 'postroll':
      return AdContentTimePosition.POSTROLL;
    default:
      return AdContentTimePosition.UNKNOWN;
  }
}
